<template>
  <div id="login">
    <div class="row h-100 justify-content-center align-items-center">
      <form class="login-form forgot-password-form form" action="map.php" method="post">
        <h3 class="text-center brand">
          <img :src="config.logo.logo_icon_only" />
        </h3>
        <div class="form-group">
          <input
            type="text"
            v-model="state.user.username"
            name="email"
            id="username"
            class="form-control"
            :placeholder="i18n.app.common.username"
          />
        </div>
        <div class="form-group text-center">
          <button
            :disabled="state.loading"
            @click.prevent="onForgotPasswordPress"
            class="btn btn-default"
            :class="state.loading && 'load-spinner'"
          >
            <span>{{ i18n.app.components.login.send_reset_link }}</span>
          </button>
        </div>
        <div class="text-center footer-brand">
          <img :src="config.logo.logo" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dialogMixin from "@/mixins/dialog.mixin";

export default {
  data() {
    return {
      state: {
        loading: false,
        user: {
          username: "",
        }
      }
    };
  },
  mixins: [dialogMixin],
  methods: {
    onForgotPasswordPress() {
      this.state.loading = true;
      this._forgotPassword({
        user: {
          ...this.state.user
        }
      })
        .then(data => {
          this.showSimpleMessage(i18n.app.login.messages.reset_link_sent);
        })
        .catch(e => {
          console.log(e);
          // this.showSimpleMessage(i18n.app.login.messages.reset_link_not_sent);
        })
        .finally(() => (this.state.loading = false));
    },
    ...mapActions({
      _forgotPassword: "forgotPassword",
    })
  }
};
</script>
